export enum AccrualModelUnitName {
  ANIMATION = "Animation",
  SECOND = "Second",
  UNIT = "Unit",
  CHAR = "Char",
  BONUS = "Bonus",
  ARTICLE = "Article",
  CHECK_FIX = "Check/Fix",
  ITEM = "Item",
  COMPILATION = "Compilation",
  CUSTOM_PAYMENT = "Custom payment",
  CUSTOM_WORK = "Custom work",
  MILLISECOND = "Millisecond",
  NOTHING = "Nothing",
  PROXY_MODEL = "",
  SCRIPT = "Script",
  SQUARE_CARD = "Square card",
  VIDEO = "Video",
  WORD = "Word",

  AMOUNT = "Amount", // only on for frontend
}

export enum QuantityMapKey {
  QUANTITY = "quantity", // only on for frontend for backward compatibility
  EMPTY = "empty", // only on for frontend when isLegacy: false, but quantity map empty

  WORK_DURATION = "workDuration",
  WORK_DURATION_MS = "workDurationMs",
  WORK_RENDER_DURATION = "workRenderDuration",
  WORK_SECONDS = "workSeconds",
  WORK_MILLISECONDS = "workMilliseconds",
  WORK_SYMBOLS_COUNT = "workSymbolsCount",
  WORK_WORDS_COUNT = "workWordsCount",
  WORK_TOTAL_SPENT_TIME = "workTotalSpentTime",
  WORK_TOTAL_AMOUNT = "workTotalAmount",
  WORK_UNITS_COUNT = "workUnitsCount",
}
